import React from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData, useForm } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { GlobalConstants } from "../../constants/GlobalConstants";

const AutoDrawsTable = () => (
  <LmsTable
    actionButtons={[
      "add", 
      "edit", 
      "remove", 
      "export", 
      {
        text: "Process",
        action: "submitselected",
        refreshDataOnSuccess: true,
        submitSuffix: "draws/process-auto-draw",
        icon: GlobalConstants.Icons.CARET_UP,
        isDisabled: (checkedItems) => checkedItems?.length !== 1,
        handleFormatSubmitSelectedRows: (data) => `"${data[0].id}"`,
      }
    ]}
    apiSuffix="draws/auto-draws"
    deleteSuffix="draws/auto-draws"
    sortable={["Created On"]}
    columnLabelsDictionary={{
      borrowerOrganization: "Borrower",
      brms: "BRMs",
      initialCos: "Initial COs",
      reviewCos: "Review COs"
    }}
  />
);

const addAutoDrawFields = (myForm, isAdd = false) => {
  myForm.addGroupFields([
    myForm.getDropdownField("Borrower", "draws/list-servicing-active-borrower-orgs", { name: "borrowerOrganizationId", required: true }),
    myForm.getDropdownField("Loan", "draws/list-servicing-active-borrower-loans", { name: "loanId", dependencyField: "borrowerOrganizationId", required: true }),
    myForm.getDropdownField("Loan Property", "loans/loan-properties", { required: true, dependencyField: "loanId" })
  ]);
  myForm.addGroupFields([
    myForm.getTextareaField("Description"),
    myForm.getCheckboxField("Needs Borrower Approval Before Submit", { inline: true })
  ]);
  myForm.addDividerField({ dividerText: "Recurrence" });
  myForm.addGroupFields([
    myForm.getBlankField(),
    myForm.getGroupRadioField("Weekly", { width: 2 }),
    myForm.getGroupRadioField("Monthly", { width: 2 }),
    myForm.getBlankField(),
    myForm.getBlankField(),
    myForm.getBlankField(),
    myForm.getBlankField()
  ], { radioGroupName: "weeklyMonthly", widths: 2 });
  myForm.addDividerField({ dividerIsHidden: true });
  myForm.addGroupFields([
    myForm.getLabelField("Recur every", { position: "right-center", width: 4 }),
    myForm.getInputField("Recur every", { 
      name: "weeklyWeeks", 
      label: "", 
      required: true,
      isDisabledOn: { weeklyMonthly: "Weekly" }, 
      isDisabledOnOperation: "notequal" 
    }),
    myForm.getLabelField("week(s) on:", { position: "left-center" }),
    myForm.getBlankField(),
  ], { widths: 2, isHidden: { weeklyMonthly: "Weekly" }, isHiddenOperation: "notequal" });
  myForm.addGroupFields([
    myForm.getBlankField(),
    myForm.getCheckboxField("Monday", { name: "weeklyMonday", position: "center", inlineRight: true, label: "" }),
    myForm.getCheckboxField("Tuesday", { name: "weeklyTuesday", position: "center", inlineRight: true, label: "" }),
    myForm.getCheckboxField("Wednesday", { name: "weeklyWednesday", position: "center", inlineRight: true, label: "" }),
    myForm.getCheckboxField("Thursday", { name: "weeklyThursday", position: "center", inlineRight: true, label: "" }),
    myForm.getCheckboxField("Friday", { name: "weeklyFriday", position: "center", inlineRight: true, label: "" }),
    myForm.getCheckboxField("Saturday", { name: "weeklySaturday", position: "center", inlineRight: true, label: "" }),
    myForm.getCheckboxField("Sunday", { name: "weeklySunday", position: "center", inlineRight: true, label: "" }),
    myForm.getBlankField(),
  ], { widths: 2, isHidden: { weeklyMonthly: "Weekly" }, isHiddenOperation: "notequal" });
  myForm.addGroupFields([
    myForm.getLabelField("Every", { position: "right-center", width: 4 }),
    myForm.getInputField("Every", { 
      name: "monthlyMonths", 
      label: "", 
      required: true,
      isDisabledOn: { weeklyMonthly: "Monthly" }, 
      isDisabledOnOperation: "notequal" 
    }),
    myForm.getLabelField("month(s) on:", { position: "left-center" }),
    myForm.getBlankField(),
  ], { widths: 2, isHidden: { weeklyMonthly: "Monthly" }, isHiddenOperation: "notequal" });
  myForm.addGroupFields([
    myForm.getCheckboxField("Day", { 
      name: "monthlyDayCheckBox", 
      position: "right-center", 
      inlineRight: true, 
      label: "", 
      width: 4,
    }),
    myForm.getInputField("DayInput", { 
      name: "monthlyDay", 
      label: "", 
      required: true,
      isDisabledOn: { monthlyDayCheckBox: true },
      isDisabledOnOperation: "notequal",
    }),
    myForm.getBlankField(),
    myForm.getBlankField(),
  ], { widths: 2, isHidden: { weeklyMonthly: "Monthly" }, isHiddenOperation: "notequal" });
  myForm.addGroupFields([
    myForm.getCheckboxField("The", {
      name: "monthlyOccurrenceCheckBox", 
      position: "right-center", 
      inlineRight: true, 
      label: "", 
      width: 4,
    }),
    myForm.getDropdownField("TheOrder", "metadata/list-monthly-occurrence-frequency", { 
      name: "monthlyOccurrenceFrequencyId", 
      label: "", 
      isDisabledOn: { monthlyOccurrenceCheckBox: true },
      isDisabledOnOperation: "notequal",
      required: true
    }),
    myForm.getDropdownField("TheWeekDay", "metadata/list-monthly-weekdays", { 
      name: "monthlyWeekdayId", 
      label: "", 
      isDisabledOn: { monthlyOccurrenceCheckBox: true },
      isDisabledOnOperation: "notequal",
      required: true
    }),
    myForm.getBlankField(),
  ], { widths: 2, isHidden: { weeklyMonthly: "Monthly" }, isHiddenOperation: "notequal" });
  myForm.addDividerField();
  myForm.addGroupFields([
    myForm.getLabelField("Start Date", { position: "right-center", width: 4, required: true }),
    myForm.getCalendarField("Start Date", { label: "", required: true }),
    myForm.getBlankField(),
    myForm.getBlankField(),
  ], { widths: 2 });
  myForm.addGroupFields([
    myForm.getCheckboxField("End Date", { 
      name: "endDateCheckbox", 
      position: "right-center", 
      inline: true, 
      width: 4,
    }),
    myForm.getCalendarField("End Date", { 
      label: "", 
      isDisabledOn: { endDateCheckbox: true }, 
      isDisabledOnOperation: "notequal",
      required: true
    }),
    myForm.getBlankField(),
    myForm.getBlankField(),
  ], { widths: 2 });
  myForm.addGroupFields([
    myForm.getCheckboxField("No End Date", { 
      position: "right-center", 
      inline: true, 
      width: 4,
    }),
    myForm.getBlankField(),
    myForm.getBlankField(),
    myForm.getBlankField(),
  ], { widths: 2 });
  myForm.addGroupFields([
    myForm.getCheckboxField("End After Occurences", { 
      name: "endAfterOccurencesCheckbox", 
      value: isAdd,
      position: "right-center",
      inline: true, 
      width: 4,
    }),
    myForm.getNumberField("End After Occurences", { 
      label: "", 
      isDisabledOn: { endAfterOccurencesCheckbox: true },
      isDisabledOnOperation: "notequal",
      required: true
    }),
    myForm.getBlankField(),
    myForm.getBlankField(),
  ], { widths: 2 });
  return myForm;
};

const AddAutoDrawForm = ({ handleCustomAutoDrawFormChange }) => {
  const myForm = addAutoDrawFields(new BCFormController({ weeklyMonthly: "Weekly", endDateCheckbox: true }, { submitSuffix: "draws/auto-draw" }), true);
  const useFormInstance = useForm(myForm?.values || {}, { myForm }) as any;
  return <LmsFormGenerator 
    myForm={myForm}  
    useFormInstance={useFormInstance} 
    onFormChanged={(options, lastUpdated) => handleCustomAutoDrawFormChange(options, lastUpdated)}
  />;
};

const EditAutoDrawForm = ({ id, handleCustomAutoDrawFormChange }) => {
  const autoDrawEndpoint = `draws/auto-draw/${id}`;
  const [{ data, isLoading, error }] = useFetchData(autoDrawEndpoint);
  const handleInitialData = () => {
    const initialData = { ...data };
    if (data?.monthlyMonths) {
      initialData.weeklyMonthly = "Monthly";
      if (data?.monthlyDay) {
        initialData.monthlyDayCheckBox = true;
      }

      if (data?.monthlyOccurrenceFrequency) {
        initialData.monthlyOccurrenceCheckBox = true;
      }
    }
    else {
      initialData.weeklyMonthly = "Weekly";
    }

    if (data?.endDate) {
      initialData.endDateCheckbox = true;
    }

    if (data?.endAfterOccurences) {
      initialData.endAfterOccurencesCheckbox = true;
    }

    return initialData;
  };

  const myForm = addAutoDrawFields(new BCFormController(handleInitialData(), { 
    submitSuffix: "draws/update-auto-draw",
    deleteSuffix: "draws/auto-draws",
    clearSuffixesOnSubmit: [autoDrawEndpoint]
  }));
  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator 
    myForm={myForm} 
    isLoading={isLoading} 
    error={error} 
    actions={formActions}
    onFormChanged={(options, lastUpdated) => handleCustomAutoDrawFormChange(options, lastUpdated)}
   />;
};

const LmsServicingAutoDraws = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  const handleCustomAutoDrawFormChange = (options, lastUpdated) => {
    let excludeFields = [] as string[] || null;
    if (lastUpdated === "endAfterOccurencesCheckbox") {
      excludeFields = ["endDateCheckbox", "endDate", "noEndDate"];
    }
    else if (lastUpdated === "endDateCheckbox") {
      excludeFields = ["noEndDate", "endAfterOccurencesCheckbox", "endAfterOccurences"];
    }
    else if (lastUpdated === "noEndDate") {
      excludeFields = ["endDateCheckbox", "endDate", "endAfterOccurencesCheckbox", "endAfterOccurences"];
    }
    else if (lastUpdated === "monthlyOccurrenceCheckBox") {
      excludeFields = ["monthlyDayCheckBox", "monthlyDay"];
    }
    else if (lastUpdated === "monthlyDayCheckBox") {
      excludeFields = ["monthlyOccurrenceCheckBox", "monthlyOccurrenceFrequencyId", "monthlyWeekdayId"];
    }
    else if (lastUpdated === "weeklyMonthly" && options.inputs[lastUpdated] === "Weekly") {
      excludeFields = ["monthlyMonths"];
    }
    else if (lastUpdated === "weeklyMonthly" && options.inputs[lastUpdated] === "Monthly") {
      excludeFields = ["weeklyWeeks", "monthlyOccurrenceCheckBox", "monthlyOccurrenceFrequencyId", "monthlyWeekdayId"];
      options.setInputs((prevInputs) => { return { ...prevInputs, monthlyDayCheckBox: true }; });
    }
  
    options.setInputs((oldInputs) => {
      excludeFields.map(field => {
        delete oldInputs[field];
      });
  
      return {...oldInputs};
    });
  
    options.setErrors((oldErrors) => {
      excludeFields.map(field => {
        delete oldErrors[field];
      });
  
      return {...oldErrors};
    });
  };

  return (<React.Fragment>
    {isMainPage && <AutoDrawsTable/>}
    {isAdd && <AddAutoDrawForm handleCustomAutoDrawFormChange={handleCustomAutoDrawFormChange} />}
    {isEdit && <EditAutoDrawForm id={id} handleCustomAutoDrawFormChange={handleCustomAutoDrawFormChange} />}
  </React.Fragment>);
};

export default LmsServicingAutoDraws;